import { useEffect } from 'react';

import { styled } from 'styled-components';
import ReactFlow, { ReactFlowProvider, useReactFlow } from 'reactflow';

import { Model, ModelDirection } from 'types';
import { EDGE_TYPES, FLOW_TYPE } from 'constants/flow';
import DataNode from './nodes/DataNode/DataNode';
import GroupNode from './nodes/GroupNode/GroupNode';
import LayerNode from './nodes/LayerNode/LayerNode';
import MemoNode from './nodes/MemoNode/MemoNode';
import ModelNode from './nodes/ModelNode/ModelNode';

const Container = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  background-color: ${(props) => props.theme.editor.flowBgColor};
`;

const Cover = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
`;

const proOptions = {
  hideAttribution: true,
};

interface ThumbnailProps {
  model: Model;
  modelDirection: ModelDirection;
}

const Thumbnail = ({ model, modelDirection }: ThumbnailProps) => {
  const { fitView } = useReactFlow();

  useEffect(() => {
    fitView();
  }, [fitView]);

  return (
    <Container>
      <Cover></Cover>
      <ReactFlow
        snapToGrid
        nodes={model.nodes}
        edges={model.edges}
        nodeTypes={{
          [FLOW_TYPE.NODE.LAYER_NODE]: (props) => <LayerNode {...props} modelDirection={modelDirection} />,
          [FLOW_TYPE.NODE.DATA_NODE]: (props) => <DataNode {...props} modelDirection={modelDirection} />,
          [FLOW_TYPE.NODE.GROUP_NODE]: (props) => <GroupNode {...props} modelDirection={modelDirection} />,
          [FLOW_TYPE.NODE.MODEL_NODE]: (props) => <ModelNode {...props} modelDirection={modelDirection} />,
          [FLOW_TYPE.NODE.MEMO_NODE]: MemoNode,
        }}
        edgeTypes={EDGE_TYPES}
        proOptions={proOptions}
      />
    </Container>
  );
};

const ThumbnailProvider = (props: ThumbnailProps) => {
  return (
    <ReactFlowProvider>
      <Thumbnail {...props} />
    </ReactFlowProvider>
  );
};

export default ThumbnailProvider;
